export enum SubscriptionType {
  light = 'LIGHT',
  lightTrial = 'LIGHTTRIAL',
  extendedTrial = 'EXTENDEDTRIAL',
  premium = 'PREMIUM'
}
